import { Box, Button, CircularProgress } from "@mui/material";
import ReactQuill from "react-quill";
import { DataCodeEnum } from "../../constants/enum";
import { ENDPOINTS, getApiUrl } from "../../common/endpoints";
import { Requests } from "../../common/requests";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import TogglePublicBtn from "../TogglePublicBtn";
import _ from "lodash";
import QuillEditor from "../QuillEditor";

interface PageContentEditorProps {
  dataCode: DataCodeEnum;
  dataName: string;
}
const PageContentEditor = ({ dataCode, dataName }: PageContentEditorProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const [content, setContent] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getPageContent();
  }, [dataCode]);

  const getPageContent = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.SAVE_PAGE_CONTENT.replace(":dataCode", dataCode)
    );
    try {
      const dataRes = await Requests.get(apiUrl);
      setData(dataRes);
      if (dataRes?.content?.data) {
        setContent(dataRes?.content?.data);
      } else {
        setContent("");
      }
    } catch (e) {
      setContent("");
    }
  };
  const handleChange = (content: string) => {
    setContent(content);
  };
  const onSave = async () => {
    setIsLoading(true);
    const apiUrl = getApiUrl(
      ENDPOINTS.SAVE_PAGE_CONTENT.replace(":dataCode", dataCode)
    );
    try {
      const data = await Requests.post(apiUrl, {
        dataName,
        content: {
          data: content,
        },
      });
      getPageContent();
      enqueueSnackbar("This is a success message!", { variant: "success" });
    } catch (e) {}
    setIsLoading(false);
  };

  const onTogglePublish = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.TOGGLE_PUBLISH_PAGE_CONTENT.replace(":dataCode", dataCode)
    );

    try {
      const data = await Requests.patch(apiUrl, {
        dataName,
      });
      getPageContent();
      enqueueSnackbar("Toggle publish success!", { variant: "success" });
    } catch (e) {}
  };
  if (content === null) {
    return <></>;
  }

  const isNotChanged = _.isEqual(content, data?.content?.data);
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        "& .quill": {
          flex: 1,
          height: "calc(100% - 60px)",
          borderRadius: "10px",
          overflow: "hidden",
          border: "1px solid #2A4365",
        },
        "& .ql-toolbar": {
          backgroundColor: "#F7FAFC",
          border: "none",
        },
        "& .ql-container": {
          height: "calc(100% - 50px)",
          border: "none",
        },
      }}
    >
      <QuillEditor value={content} onChange={handleChange} />
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          paddingTop: "10px",
        }}
      >
        <TogglePublicBtn
          isValidated={!!data?.ispublished}
          onToggle={() => {
            onTogglePublish();
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => onSave()}
          disabled={isNotChanged || isLoading}
          sx={{
            textTransform: "unset",
          }}
        >
          {isLoading && (
            <CircularProgress
              size="20px"
              sx={{
                marginRight: "10px",
                color: "#fff",
              }}
            />
          )}
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default PageContentEditor;
